import styled from 'styled-components'
import { theme } from '~/styles'

export const Container = styled.div`
  position: relative;

  flex: 1 1 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-flow: column;
  flex-direction: column;
  overflow: hidden;
`

export const ContainerTable = styled.div`
  position: relative;
  padding: 16px 12px;
  width: 100%;
  display: flex;
  flex-flow: column;
  flex: 1 1 auto;
  overflow: hidden;

  background-color: ${({ theme }) => theme.zds.colors.neutral1000};
  border-radius: ${({ theme }) => theme.zds.border.radius100};
`

export const TableFiltersHeader = styled.div`
  position: relative;
  margin-bottom: 15px;
  flex: 0 1 auto;

  display: grid;
  grid-template-columns: 135px auto;
  grid-column-gap: 10px;
`
